import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { TabAnchor } from './types';

// Desktop height of no reviews and title
const MIN_HEIGHT_DESKTOP_REVIEWS = '400px';
// Desktop height of statistics, title and top ad
const MIN_HEIGHT_DESKTOP_STATISTICS = '680px';

type SectionWrapperProps = {
  id: TabAnchor;
  $isActive?: boolean;
  $isVisible: boolean;
  $newTabNav: boolean;
};

export const SectionWrapper = styled.div<SectionWrapperProps>(
  props => css`
    display: ${props.$isVisible ? 'block' : 'none'};

    ${props.id === TabAnchor.REVIEWS &&
      css`
        min-height: ${MIN_HEIGHT_DESKTOP_REVIEWS};
      `}

    ${props.id === TabAnchor.PROPERTIES &&
      css`
        min-height: 255px;

        ${media.mediumUp`
          min-height: 750px;
        `}
      `}

      ${props.id === TabAnchor.STATISTICS &&
        css`
          min-height: 343.094px;

          ${media.mediumUp`
            min-height: ${
              props.$newTabNav ? MIN_HEIGHT_DESKTOP_STATISTICS : '549.5px'
            };
          `}
        `}

    ${props.$newTabNav &&
      props.$isActive &&
      css`
        margin-top: ${layout.measurements.spacing100};
      `}
  `
);

type AdWrapperProps = {
  $visible: boolean;
};

export const AdWrapper = styled.div<AdWrapperProps>(
  props => css`
    display: ${props.$visible ? 'block' : 'none'};
  `
);
